@import '../../theme.scss';

.logolist {
    background-color: #222223;
    margin-top: $menuHeight;
    .logo-img {
        width: 100%;
        height: 100%;
        padding: 5%;
    }
}
